import api from './api';

// Features API
export const featuresApi = {
  getAll: () => api.get('/features'),
  getById: (id) => api.get(`/features/${id}`)
};

// Integration Categories API
export const integrationCategoriesApi = {
  getAll: () => api.get('/integration-categories'),
  getById: (id) => api.get(`/integration-categories/${id}`)
};

// Integration Companies API
export const integrationCompaniesApi = {
  getAll: () => api.get('/integration-companies'),
  getById: (id) => api.get(`/integration-companies/${id}`)
};

// FAQ Categories API
export const faqCategoriesApi = {
  getAll: () => api.get('/faq-categories'),
  getById: (id) => api.get(`/faq-categories/${id}`)
};

// FAQ Questions API
export const faqQuestionsApi = {
  getAll: () => api.get('/faq-questions'),
  getById: (id) => api.get(`/faq-questions/${id}`),
  getForHomepage: () => api.get('/faq-questions/homepage')
};

// Bank Accounts API
export const bankAccountsApi = {
  getAll: () => api.get('/bank-accounts'),
  getById: (id) => api.get(`/bank-accounts/${id}`)
};

// Contact Info API
export const contactInfoApi = {
  getAll: () => api.get('/contact-info'),
  getByType: (type) => api.get(`/contact-info/type/${type}`)
};

// Client References API
export const clientReferencesApi = {
  getAll: () => api.get('/client-references'),
  getById: (id) => api.get(`/client-references/${id}`)
};
